import { SortPagination } from 'utils/paginations';
import { api } from './api';

export async function getAchievements(filters?: any[], limit = 100) {
  const payload: any[] = [];

  if (filters) {
    payload.concat(filters);
  }

  payload.push({
    $sort: {
      time: -1,
    },
  });

  if (limit) {
    payload.push({
      $limit: limit,
    });
  }

  const { data } = await api.post(`database/achievement/aggregate`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getPointsHistory(player?: string, start?: any, end?: any, filter?: any) {
  try {
    let payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    // console.log(payload);
    const { data } = await api.post('find/extrato_pontos', payload, {
      headers: { Range: 'items=0-1000' },
    });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getPointsSummary(player?: string, start?: any, end?: any, filter?: any) {
  try {
    let payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    if (!!filter) {
      payload = { ...payload, ...filter };
    }
    const { data } = await api.post('find/extrato_resumo', payload, {
      headers: { Range: 'items=0-1000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function getReconhecimentos(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/resultado_reconhecimento', payload, {
      headers: { Range: 'items=0-1000' },
    });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getDestaqueCultura(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/resultado_cultura', payload, {
      headers: { Range: 'items=0-1000' },
    });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getMissaoGestor(player?: string, cycleId?: any) {
  try {
    const payload = {
      player,
      cycleId,
    };

    const { data } = await api.post('find/extrato_missao_gestor', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoGestorByPeriod(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    const { data } = await api.post('find/extrato_missao_gestor_period', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoGestorPublic(player?: string, start?: any, end?: any, cycleId?: string) {
  try {
    const payload = {
      player,
      start,
      end,
      cycleId
    };

    const { data } = await api.post('find/extrato_missao_gestor_public', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipe(player?: string, cycleId?: any, filter?: any) {
  try {
    let payload = {
      player,
      cycleId,
    };

    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    // console.log(payload);

    const { data } = await api.post('find/extrato_missao_equipe', payload, {
      headers: { Range: 'items=0-1000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipeEcoa(player?: string, cycleId?: any, filter?: any) {
  try {
    let payload = {
      player,
      cycleId,
    };

    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    // console.log(payload);

    const { data } = await api.post('find/extrato_missao_equipe_ecoa', payload, {
      headers: { Range: 'items=0-1000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getRakingByCycle(player?: string, grupo?: string, cycleId?: string) {
  try {
    let payload = {
      player,
      grupo,
      cycleId,
    };

    const { data } = await api.post('find/get_raking_by_cycle', payload, {
      headers: { Range: 'items=0-1000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipePrefixo(
  prefixo?: number,
  start?: any,
  end?: any,
  cycleId?: any,
  faseId?: any,
  search?: string,
  rang?: number,
  pontos?: any,
  totalItems?: number
) {
  try {
    let payload = {
      prefixo,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
      cycleId,
      faseId,
      search: search ? search : null,
      pontos,
    };

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/extrato_missao_equipe_prefixo', payload, {
      headers: { Range: `items=${rangeStart}-${totalItems ? totalItems : 20}` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipeFeedback(player?: string, cycleId?: any) {
  try {
    const payload = {
      player,
      cycleId,
    };

    const { data } = await api.post('find/extrato_missao_gestor_feedback', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoGestorBonusColaboracao(player?: string, cycleId?: any) {
  try {
    const payload = {
      player,
      cycleId,
    };

    const { data } = await api.post('find/extrato_missao_gestor_bonus_colaboracao', payload, {
      headers: { Range: 'items=0-1000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoGestorBonusPrazo(player?: string, cycleId?: any) {
  try {
    const payload = {
      player,
      cycleId,
    };

    const { data } = await api.post('find/extrato_missao_gestor_bonus_prazo', payload, {
      headers: { Range: 'items=0-1000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipeByTime(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    const { data } = await api.post('find/extrato_missao_equipe_period', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipePublic(player?: string, start?: any, end?: any, cycleId?: string ) {
  try {
    const payload = {
      player,
      start,
      end,
      cycleId
    };

    const { data } = await api.post('find/extrato_missao_equipe_public', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}
